export default function setPageTitle() {
	const lang = localStorage.getItem('lang') || 'zh';

	window.document.title =
		lang === 'en' ? 'ChaoZhou Three-Circle (Group) CO.,LTD.' : '三环集团';
}
